<ng-container *ngIf="!errorLoading">
    <div class="container">
     
        <div class="m-box" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center;flex-direction: column;">
            <ng-container *ngIf="!appointmentSuccesses && exam  && patient">
            <div class="w100" style="display: flex; ;flex-direction: column; align-items: flex-start; justify-content: center; width: 100%;">
                <span style="margin-left: 0.3em;margin-bottom: 0.3em; "> {{exam.custom?exam.examType:exam.examName}}</span>
                <span *ngIf="Fetus" style="margin-left: 0.3em;margin-bottom: 0.3em; "> {{Fetus}}</span>
                <!-- <span style="margin-left: 0.3em;margin-bottom: 0.3em; "> {{length}} דקות </span> -->
                <div style="display: flex;align-items: center;margin-bottom: 0.3em;">
                
            </div>
               
                <span style="margin-left: 0.3em;;margin-bottom: 0.3em; ">שם: {{ patient.Last }}  {{ patient.First }}</span>
                <span style="margin-left: 0.3em; ;margin-bottom: 0.3em;"> תז: {{ patient.ID }}  </span>
                <!-- <span style="margin-left: 0.3em; ;margin-bottom: 0.3em;">נייד: {{ this.patient.Mobile }}  </span> -->
             
            </div>
            <ng-container *ngIf="!calendarReady">
              <img src="../../assets/images/Wedges.svg"/>
            </ng-container>
           <ng-container *ngIf="calendarReady">
            <mat-card class="demo-inline-calendar-card">
                <mat-calendar [(selected)]="selected" [minDate]="minDate" [maxDate]="maxDate" [dateFilter]="myFilter" (selectedChange)="onDateSelect($event)"></mat-calendar>
             </mat-card>
             <!-- <h5>המערכת מציגה לך תורים בטווח התאריכים בהם מקובל לבצע בדיקה מסוג זה במרפאתנו, אם לא הוצג לך תור פנוי באופן אוטומטי יש לפנות למזכירות לתיאום תור</h5> -->
            </ng-container>
             <div class="containerSlots">
                <div *ngIf="slotsDateSelected && slotsDateSelected.length" class="time-slots-grid">
                  <button *ngFor="let slot of slotsDateSelected | uniqueSlots:'slotTime'| sortSlots:'slotTime'" 
                  (click)="onSlotSelect(slot)" 
                  [ngClass]="{'selected-time-slot': slot === confirmation}" 
                  class="time-slot-button">
                {{ slot.slotTime  | date:"HH:mm" }}
          </button>
                </div>
                            </div>
              <div style="display: flex; justify-content: center; width: 100%; margin-bottom: 1em;">
                <button *ngIf="confirmation" (click)="AutoIndex?updateAppointment(): saveAppointment()" class="blue-btn">
                   לאישור מועד התור שנבחר
              </button>
              </div>
              <div style="display: flex; justify-content: flex-start; width: 100%; padding-right: 1em;">
              <button (click)="exitWithoutAppointment()" class="green-btn">
                יציאה מהמערכת ללא תור
              </button>
              </div>
        </ng-container>
        <ng-container *ngIf="appointmentSuccesses && !AutoIndex">
         <h3>שלום לך  {{ patient.First }} {{ patient.Last }} </h3>
        <h3>נקבע לך תור במרפאת {{clinic.clinicTitle}} </h3>
        <h3>
            ל{{ exam.custom? exam.examType:exam.examName  }}
            {{getFundingText()}}
        </h3> 
        <h3  >
            ביום {{ (confirmation.slotTime | date:'EEEE' | translateDate:'day') }}
            -ה{{ confirmation.slotTime | date:'dd' }}
            ל{{ (confirmation.slotTime | date:'MMMM' | translateDate:'month') }}
            בשעה {{ confirmation.slotTime | date:'HH:mm' }}
          </h3>
          <h3 *ngIf="clinic.wazeLink">
            להגעה בוויז: <a [href]="clinic.wazeLink" target="_blank" class="link-with-border">{{ clinic.wazeLink }}</a>
          </h3>

        </ng-container>
        <ng-container *ngIf="appointmentSuccesses && AutoIndex">
          <h3>שלום לך  {{ patient.First }} {{ patient.Last }} </h3>
         <h3> תור במרפאת {{clinic.clinicTitle}}  </h3>
         <h3>
            ל{{ exam.custom? exam.examType:exam.examName  }}
             עודכן
             ל{{ (confirmation.slotTime | date:'EEEE' | translateDate:'day') }}
             ה{{ confirmation.slotTime | date:'dd' }}
             ל{{ (confirmation.slotTime | date:'MMMM' | translateDate:'month') }}
             בשעה {{ confirmation.slotTime | date:'HH:mm' }}
           </h3>
           <h3 *ngIf="clinic.wazeLink">
             להגעה בוויז: <a [href]="clinic.wazeLink" target="_blank" class="link-with-border">{{ clinic.wazeLink }}</a>
           </h3>
 
         </ng-container>

            
        </div>
    </div>


</ng-container>
  